import { React, useState, useEffect } from "react";
import { MovieTagList } from "../../MovieTag/MovieTagList.js";
import { FilterPagination } from "./FilterPagination.js";
//Redux
import { useSelector, useDispatch } from "react-redux";
//Style
import "./FilterResult.css";
//API
import { extractMovData } from "../../../utility/utility.js";
import { extractTvData } from "../../../utility/utility.js";
//Testing Sort
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { getFilterResult } from "../../../page/FilterPage/FilterSlice.js";

export const FilterResult = (props) => {
  let {
    apiUtility: { langConfig, countryConfig, movGenreList, tvGenreList },
    setShowFilter
  } = props;

  let [layoutType, setLayoutType] = useState("list");
  let [sortOption, setSortOption] = useState("popularity");
  let [sortOrder, setSortOrder] = useState(false); //true = asc false = desc

  let genreList =
    useSelector((state) => state.filter.type) == 0 ? movGenreList : tvGenreList;

  let filterType = useSelector((state) => state.filter.filterList.type);
  let filterResultList = useSelector((state) => state.filter.filterResultList);

  //Update Sort Option
  const dispatch = useDispatch();
  useEffect(() => {
    const sortRequest = sortOrder ? sortOption + ".asc" : sortOption + ".desc";
    dispatch(
      modifyFilterList({
        field: "sort",
        payload: [sortRequest],
      })
    );
    dispatch(
      modifyFilterList({
        field: "page",
        payload: 1
      })
    )
  }, [sortOption, sortOrder]);

  let filterList = useSelector((state) => state.filter.filterList);
  //Update Filter Result
  useEffect(() => {
    dispatch(getFilterResult(filterList));
  }, [filterList, sortOption, sortOrder]);

  return (
    <div className="filter_result_wrapper">
      <div className="filter_result_upper">
        <div className="filter_result_title">RESULT</div>
        <div className="filter_result_sort_wrapper">
          <div
            className="filter_result_show_filter"
            onClick={() => setShowFilter(true)}
          >
            <span>Add Filter</span>
            <i className="fa-solid fa-plus"></i>
          </div>
          <div className="filter_result_sort">
            <select
              onChange={(e) => setSortOption(e.target.value)}
              value={sortOption}
              name="sorting"
              id="sorting-select"
            >
              <option value="" disabled selected>
                Sort
              </option>
              <option value="popularity">Popularity</option>
              <option value="revenue">Revenue</option>
              <option value="primary_release_date">Release Date</option>
            </select>
          </div>
          <div
            className="filter_result_sort_order"
            onClick={() => setSortOrder((prev) => !prev)}
          >
            {sortOrder == true ? (
              <i className="fa-solid fa-arrow-up-wide-short"></i>
            ) : (
              <i className="fa-solid fa-arrow-down-wide-short"></i>
            )}
          </div>
          <div className="filter_result_switch_view">
            <div
              className={`switch_view_item ${
                layoutType == "grid" ? "switch_view_active" : ""
              }`}
              onClick={() => setLayoutType("grid")}
            >
              <i className="fa-solid fa-grip"></i>
            </div>
            <div
              className={`switch_view_item ${
                layoutType == "list" ? "switch_view_active" : ""
              }`}
              onClick={() => setLayoutType("list")}
            >
              <i className="fa-solid fa-list"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="filter_result_content_wrapper">
        {filterResultList.filterResultLoading ? (
          <div>Loading...</div>
        ) : filterResultList.filterResultError ? (
          <div>Error 404</div>
        ) : (
          <MovieTagList
            layoutType={layoutType}
            movieType={filterType == 0 ? "mov" : "tv"}
            movieItems={filterResultList.filterResult.map((item) =>
              filterType == 0
                ? extractMovData(item, langConfig, countryConfig, genreList)
                : extractTvData(item, langConfig, countryConfig, genreList)
            )}
          />
        )}
      </div>
      <div className="filter_result_pagination">
        <FilterPagination/>
      </div>
    </div>
  );
};
